import { SCHOOL_HAS_LIFETIME_DATA } from './has-lifetime-data-actions';

const initialState = false;

/**
 * Has Lifetime Data Reducer
 *
 * Consumes SCHOOL_HAS_LIFETIME_DATA action
 *
 * @access public
 * @param {boolean} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {boolean} - whether school has extended results
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case SCHOOL_HAS_LIFETIME_DATA:
            return action.payload;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./components/report-filters/redux/has-lifetime-data/has-lifetime-data-reducer.js